import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
	children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
	const location = useLocation();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// Start invisible and fade in
		setIsVisible(false);

		// Small delay then fade in
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 250);

		return () => clearTimeout(timer);
	}, [location.pathname]);

	return (
		<div 
			data-page-transition
			className={`${isVisible ? 'opacity-100 transition-opacity duration-500 ease-in-out' : 'opacity-0 transition-none'}`}>
			{children}
		</div>
	);
}
